import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_6 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_10 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_11 = {
  key: 0,
  class: "col-12"
}
const _hoisted_12 = {
  key: 1,
  class: "col-12"
}
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_14 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "row justify-content-center" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" NAME "),
            _createElementVNode("div", {
              class: _normalizeClass({ 'col-lg-8': _ctx.update, 'col-md-6': !_ctx.update })
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('form.title.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consent.title) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.title }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.consent.title]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.title ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.title, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */),
            _hoisted_7,
            _createCommentVNode(" DESCRIPTION "),
            _createElementVNode("div", {
              class: _normalizeClass({ 'col-lg-8': _ctx.update, 'col-md-6': !_ctx.update })
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consent.description) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.description }]]),
                  rows: "6"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.consent.description]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.description ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.description, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('cta.delete_consent')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("button", {
                      class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                      type: "submit",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitted = true))
                    }, _toDisplayString(_ctx.$t('cta.save_consent')), 1 /* TEXT */)
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteConsent())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}